import { Component, Injectable, ViewChild, OnInit } from '@angular/core';
import { RequestsService } from '../../services/requests.service';
import { ToastService } from '../../services/toast.service';
import { CustomvalidationService } from '../../services/customvalidation.service';
import { ModalComponent, ModalConfig } from '../../_helpers/modal/modal.component'
import { ModalperguntaComponent} from '../../_helpers/modalpergunta/modalpergunta.component'
import { Tenant } from '../../models/tenant.model';
import { MonacoEditorComponent } from '@materia-ui/ngx-monaco-editor';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'add-tenant',
  styleUrls: ['./add-tenant.component.scss'],
  templateUrl: "./add-tenant.component.html"
})

export class AddTenantComponent implements ModalConfig, OnInit{
  tenantForm: FormGroup;    
  submitted = false;
  disableSubmit = false;
  public data: string;
  public idProjeto: number;
  public modalTitle = "Cadastro/Edição de Tenant";
  public modalperguntaTitle = "Tem certeza que gostaria de excluir o Tenant?";
  public closeButtonLabel = "Fechar";
  tenant: Tenant = new Tenant();

  editorOptions = {theme: 'vs-dark', language: 'json'};
  @ViewChild('editor', { static: true }) private editor: MonacoEditorComponent
  @ViewChild('modal', { static: true }) private modalComponent: ModalComponent
  @ViewChild('modalpergunta', { static: true}) private modalperguntaComponent: ModalperguntaComponent

  constructor (private formBuilder: FormBuilder,
    private requestService: RequestsService,
    private customValidation: CustomvalidationService,
    private toastService: ToastService) {}

  ngOnInit() {
    this.tenantForm = this.formBuilder.group({
      nome: ['', Validators.required],
      stringConexao: ['', Validators.required],
      multiTenant: [''],
      comandoRecuperarDadosConexao: [''],
      objetoConfigComandoJson: [''],
      parametroDistintorTenantWhere: ['']
    }, {
      validators: [this.customValidation.checkboxConditionalRequired('multiTenant', 'comandoRecuperarDadosConexao', true),
        this.customValidation.checkboxConditionalRequired('multiTenant', 'objetoConfigComandoJson', true),
        this.customValidation.checkboxConditionalRequired('multiTenant', 'parametroDistintorTenantWhere', true)]
    })
  }

  get f() { return this.tenantForm.controls; }


  public hideDismissButton() {
    return true;
  }

  async abrir(registro, idProjeto) {
    this.disableSubmit = false;
    this.submitted = false;
    this.tenantForm.markAsUntouched();

    if (registro)
      this.tenant = registro;
      else
      this.tenant = new Tenant();

    this.idProjeto = idProjeto;
    return await this.modalComponent.open();
  }

  async fechar() {
    await this.modalComponent.close();
  }

  jsonObject(str) {
    if (!str)
      return "";

    return JSON.parse(str.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": '));
  }

  validateJson(str) {
    try {
      this.jsonObject(str);
      return true;
    }
    catch (e) {
      return false;
    }
  }

  salvar() {
    this.submitted = true;

    if (this.tenantForm.invalid) {
      return;
    }

    if (this.editor.validate()) {
      alert("Forneça o id do projeto.");
      return;
    }

    this.disableSubmit = true;
    this.tenant.idProjeto = this.idProjeto;
    var request = this.tenant.idTenant > 0 ? this.requestService.updateTenant(this.tenant) : this.requestService.insertTenant(this.tenant);

    request.subscribe(rsp => {
      this.fechar();
      this.toastService.showSuccess("Tenant salvo com sucesso.");
    }, err => {
      this.disableSubmit = false;
    });
  }

  async delete(id) {
    await this.modalperguntaComponent.open();
    return await this.modalperguntaComponent.continue(this.modalperguntaComponent.isConfirmed);
  }  

}
